export const fonts = name =>
    ({
        regular: 'Rubik',
        custom: 'Debby',
    }[name]);



// WEBPACK FOOTER //
// ./src/Assets/fonts.js